export const getFieldFromState = (state: any, code: number) => {
  return state && state[Object.keys(state).find((key) => state[key].code === code) || ''];
};
